import { useState } from 'react';

import './complete-profile-modal.scss';

import { isValidZAPhone } from '../../../utils/phone/phone';
import { Button } from '../../common/button/Button';
import { PhoneInput } from '../../common/phone-input/PhoneInput';
import { AdaptiveModal } from '../AdaptiveModal';

export const CompleteProfileModal = ({
  open,
  onOpen,
  needName,
  needContactNumber,
  initialName = '',
  initialContactNumber = '',
  onSubmit
}) => {
  const [name, setName] = useState(initialName);
  const [contactNumber, setContactNumber] = useState(initialContactNumber);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const e = {};
    if (needName && !name.trim()) e.name = 'Name is required';
    if (needContactNumber && !isValidZAPhone(contactNumber)) {
      e.contactNumber = 'Valid phone number required';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;
    onSubmit({
      name: needName ? name.trim() : undefined,
      contactNumber: needContactNumber ? contactNumber : undefined
    });
  };

  return (
    <AdaptiveModal
      open={open}
      onOpen={onOpen}
      contentStyle={{ minWidth: '320px', width: '420px', maxWidth: '96vw' }}
      mobileAutoHeight
      mobilePadded
    >
      <div className="cpm">
        <h2 className="cpm__title">Just need a few more details</h2>
        <p className="cpm__sub">We use this to keep you posted about your order.</p>
        <form className="cpm__form" onSubmit={handleSubmit}>
          {needName && (
            <div className="cpm__field">
              <label className="cpm__label">Name</label>
              <input
                type="text"
                className={`cpm__input ${errors.name ? 'cpm__input--error' : ''}`}
                placeholder="Your name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {errors.name && <span className="cpm__field-error">{errors.name}</span>}
            </div>
          )}
          {needContactNumber && (
            <div className="cpm__field">
              <label className="cpm__label">Phone number</label>
              <PhoneInput value={contactNumber} onChange={setContactNumber} hasError={!!errors.contactNumber} />
              {errors.contactNumber && <span className="cpm__field-error">{errors.contactNumber}</span>}
            </div>
          )}
          <Button>Continue</Button>
        </form>
      </div>
    </AdaptiveModal>
  );
};
